<template>
<div>
  <div class="columns">
    <div class="column is-8">
      <div class="box">
        <admin-box-item title="예약 캘린더">
          <resv-calendar @clickDate="clickDate"></resv-calendar>
        </admin-box-item>
      </div>
    </div>
    <div class="column is-4">
      <div class="box">
        <admin-box-item title="예약  현황">
          <div class="columns is-multiline" v-if="resvDate">
            <div class="column is-full">
              <admin-form-item label="일정">
                <div>{{ resvDate.dateStr }}</div>
              </admin-form-item>
            </div>
            <div class="column is-full" style="margin-top:12px">
              <admin-form-item label="예약 상세 정보">
                <card-resv v-for="(resv, idx) in resvs" :key="'resv-'+idx" :card="resv" @refresh="getResvs"></card-resv>
                <div class="empty-view" v-if="resvs && resvs.length===0">예약 내역이 없습니다</div>
              </admin-form-item>
            </div>
          </div>
        </admin-box-item>
      </div>
    </div>
  </div>
</div>
</template>

<script>
  import ResvCalendar from "./component/ResvCalendar";
  import CardResv from "./component/CardResv";
  export default {
    name: "OrderCalendar",
    components: {CardResv, ResvCalendar},
    data() {
      return {
        resvDate: undefined,
        resvs: undefined
      }
    },
    methods: {
      clickDate(date) {
        this.resvDate = date;
        this.getResvs();
      },
      getResvs() {
        this.resvDate.dateStr = `${this.datesFormat(this.resvDate.date, 'date_2')}`;
        this.resvs = undefined;
        this.$axios.get(this.getUrl(`booking/order?resv_date=${this.resvDate.date}&resv_end_date=${this.resvDate.date}`)).then(res => {
          this.resvs = res.data.data;
        });
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .empty-view
    font-size 13px
    text-align center
    margin 40px 0
</style>
